var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon parking lot",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.857 8V5.714h1.714a1.143 1.143 0 0 1 0 2.286zm6.857-8A2.287 2.287 0 0 1 16 2.286v11.428A2.288 2.288 0 0 1 13.714 16H2.286A2.287 2.287 0 0 1 0 13.714V2.286A2.286 2.286 0 0 1 2.286 0zM12 6.857a3.409 3.409 0 0 0-3.429-3.429H6a1.428 1.428 0 0 0-1.429 1.429v6.571a1.143 1.143 0 0 0 2.286 0v-1.142h1.714A3.429 3.429 0 0 0 12 6.857z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIcon);
export default __webpack_public_path__ + "static/media/parking-icon.7efadffd4041bd6bc622ec3fc527b107.svg";
export { ForwardRef as ReactComponent };